import { Component, Input } from '@angular/core';

import { ZoomTransformation } from '../../../common/zoom/models/zoom-model';
import { bubbleScale } from '../../../helpers/chartHelpers';
import {
  WorldMapCategoryMap,
  WorldMapCountry,
  WorldMapData,
  WorldMapFeature,
  WorldMapPie,
  WorldMapPieArc
} from '../../models/worldmap-model';

import { CommonModule } from '@angular/common';
import * as d3 from 'd3';

@Component({
  selector: '[chart-pie]',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg:g
      class="symbol-wrapper"
      [ngClass]="'symbol-wrapper-' + feature.id"
      [attr.transform]="'translate(' + feature.centroid[0] + ',' + feature.centroid[1] + ')'"
    >
      <svg:g class="symbol-pie" [attr.transform]="'scale(' + radius + ')'">
        <svg:circle class="symbol-pie-white" [attr.cx]="0" [attr.cy]="0" [attr.r]="1" [attr.stroke-width]="0.5 / radius" />

        <svg:path *ngFor="let arc of arcs" [attr.fill]="arc.color" [attr.d]="arc.arc"></svg:path>
      </svg:g>
    </svg:g>
  `,
  styleUrls: ['./pie.component.scss']
})
export class PieComponent {
  @Input()
  categoryMap: WorldMapCategoryMap;

  @Input()
  feature: WorldMapFeature;

  @Input()
  transform: ZoomTransformation;

  @Input()
  circleSizes: Array<number>;

  //  Public variables to draw the Pies
  public radius: number;
  public arcs: Array<WorldMapPieArc>;

  private _dataRange: Array<number>;
  @Input()
  set dataRange(dr: Array<number>) {
    this._dataRange = dr;
    this.generateVisuals();
  }

  private _country: WorldMapCountry;
  @Input()
  set country(country: WorldMapCountry) {
    this._country = country;
    this.generateVisuals();
  }

  private pieArcsGenerator(data: Array<WorldMapData>) {
    const arc = d3.arc().innerRadius(0).outerRadius(1);

    const pie: Array<WorldMapPie> = d3
      .pie()
      .value((d: WorldMapData) => d.value)
      .sort(null)(data);

    const piePaths = [];

    pie.forEach((element: WorldMapPie) => {
      piePaths.push({
        arc: arc(element),
        color: this.categoryMap[element.data.category].color
      });
    });

    return piePaths;
  }

  /**
   * Set this.radius and this.arcs based on the inputs country and dataRange
   * Should be triggered when both inputs are set because we can't depend
   * on them being set simultaneously
   */
  private generateVisuals() {
    if (!this._dataRange || !this._country) {
      return;
    }
    this.radius = bubbleScale(this._dataRange, this._country.scaledCount || this._country.count, this.circleSizes);
    this.arcs = this.pieArcsGenerator(this._country.data);
  }
}
